import type { Patient, Reference } from '@medplum/fhirtypes'
import type { Participant } from '@seen/core/models/patients/participant'
import { useMemo } from 'react'

// The value an editor gives `EditorParticipantContext`: stable while the
// participant is the same one, since the model is re-created on every fetch.
export function useEditorParticipant(
  participant: Participant | null | undefined
): Reference<Patient> | null | undefined {
  const none = participant === null
  const reference = participant?.reference.reference
  return useMemo(() => {
    if (none) {
      return null
    }
    return reference ? { reference } : undefined
  }, [none, reference])
}
